import { RewardsPoints, RewardsPointsData } from 'src/types/RewardsPoints'

export function rewardPointsMapper(
  rewardPoints: RewardsPointsData
): RewardsPoints {
  return {
    slug: rewardPoints.slug,
    value: rewardPoints.valor,
    points: rewardPoints.pontos,
  }
}
